import styled from "styled-components";

import colors from "core/colors";
import Flexbox from "core/Flexbox";
import BodyText from "core/BodyText";
import OrderSummaryItem from "core/CheckoutForm/OrderSummaryItem";

import { convertPxToRem } from "frontend/components/helpers";

export const SummaryContainerItem = styled(Flexbox)`
    border-top: 1px solid ${colors.primary.scheifer};
    border-bottom: 1px solid ${colors.primary.scheifer};

    padding-top: ${convertPxToRem({ px: 24 })};
    padding-bottom: ${convertPxToRem({ px: 24 })};

    margin-bottom: ${convertPxToRem({ px: 24 })};

    &:first-of-type {
        border-top: 1px solid ${colors.primary.scheifer};
        padding-top: ${convertPxToRem({ px: 24 })};
    }
`;

export const SummaryContainerChild = styled.div``;

export const InlineBodyText = styled(BodyText)`
    display: inline-block;
    margin: 0 ${convertPxToRem({ px: 8 })}; /* 8px */
`;

export const SummaryBalanceDetails = styled(OrderSummaryItem)`
    img {
        max-height: ${convertPxToRem({ px: 40 })};
        margin-right: ${convertPxToRem({ px: 8 })};
    }
`;
